export const VISITOR_SEARCH_REQUEST = '[VISITOR] VISITOR_SEARCH_REQUEST';
export const VISITOR_SEARCH_SUCCESS = '[VISITOR] VISITOR_SEARCH_SUCCESS';
export const VISITOR_SEARCH_FAILED = '[VISITOR] VISITOR_SEARCH_FAILED';

export const GET_VISITOR_REQUEST = '[VISITOR] GET_VISITOR_REQUEST';
export const GET_VISITOR_SUCCESS = '[VISITOR] GET_VISITOR_SUCCESS';
export const GET_VISITOR_FAILED = '[VISITOR] GET_VISITOR_FAILED';

export const EDIT_VISITOR_REQUEST = '[VISITOR] EDIT_VISITOR_REQUEST';
export const EDIT_VISITOR_SUCCESS = '[VISITOR] EDIT_VISITOR_SUCCESS';
export const EDIT_VISITOR_FAILED = '[VISITOR] EDIT_VISITOR_FAILED';

export const RESET_VISITOR_FORM = '[VISITOR] RESET_VISITOR_FORM';